(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("itowns_potree2worker", [], factory);
	else if(typeof exports === 'object')
		exports["itowns_potree2worker"] = factory();
	else
		root["itowns_potree2worker"] = factory();
})(self, () => {
return 